import { useEffect } from 'react';

interface BreadcrumbItem {
  name: string;
  href: string;
}

const BASE_URL = 'https://antz.ai';

export function useBreadcrumbJsonLd(items: BreadcrumbItem[]) {
  useEffect(() => {
    const breadcrumbList = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: `${BASE_URL}${item.href}`,
      })),
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-breadcrumb', 'true');
    script.textContent = JSON.stringify(breadcrumbList);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [items]);
}
